import React from "react";
import styled from "styled-components/macro";
import "../../assets/css/common.css";
import { spacing } from "@material-ui/system";
import {
  Typography as MuiTypography,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Box from "@material-ui/core/Box";
import Space from "../../components/Space";

const Typography = styled(MuiTypography)(spacing);

function Loading(props) {
  return (
    <>
      {/*<Typography mb={'228px'}/>*/}
      <Space height={props.top ? props.top : '228px'}></Space>
      <Box display='flex' flexDirection={'column'} alignItems='center' justifyContent='center'>
        <div className='progress'>
          <CircularProgress  />
        </div>
        <div className='s20'></div>
        {/*<Typography variant={'body1'}>Loading ..</Typography>*/}
      </Box>
      <Space height={props.bottom ? props.bottom : '0px'}></Space>
    </>
  );
}

export default Loading;
